import { render, staticRenderFns } from "./EquipmentEditor.vue?vue&type=template&id=019794a8"
import script from "./EquipmentEditor.vue?vue&type=script&lang=js"
export * from "./EquipmentEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports